/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { Field, Form } from 'formik';
import { Button, CircularProgress, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select } from '@mui/material';
import { TextField } from 'formik-mui';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { getAllKeyCloakUsers } from '../../../../../../store/reducers/keyCloak/keyCloakAction';
import { getAllPersonnelUserList } from '../../../../../../store/reducers/personnel/personnelAction';

const KeycloakUserCreationForm = ({ values, handleBlur, handleChange, errors, touched, handleClose, isSubmitting }) => {
    const [showPassword, setShowPassword] = React.useState(false)


    const users = useSelector(state => state.keycloak.keyCloakUsers);
    const personnelUsers = useSelector(state => state.personnel.personnelUsers);

    const dispatch = useDispatch();

    const fetchUsers = React.useCallback(async () => {
        try {
            await dispatch(getAllKeyCloakUsers({ "realm": "getchkd" })).unwrap();
            await dispatch(getAllPersonnelUserList()).unwrap();

        } catch (error) {
        }
    }, [dispatch]);


    React.useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);
    return (


        <Form>

            <Grid container spacing={4}> 
                {values.hasOwnProperty("realm")&& <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth >

                        <Field
                            name="realm"
                            label="Realm"
                            type="text"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.realm}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            disabled
                            component={TextField}
                        />
                    </FormControl></Grid>
                }
                {values.hasOwnProperty("username") && <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth >

                        <Field
                            name="username"
                            label="User Name"
                            type="text"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.username}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            component={TextField}
                        />
                    </FormControl></Grid>
                }
                {values.hasOwnProperty("password")&& <Grid item xs={12} md={12} sm={12}>
                    <Grid container spacing={2}>

                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl fullWidth error={Boolean(touched.password && errors.password)}>

                                <Field
                                    name="password"
                                    label="Password"
                                    type={showPassword ? "text" : 'password'}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    margin="normal"
                                    variant="outlined"
                                    fullWidth
                                    value={values.password}
                                    component={TextField}
                                    InputProps={{

                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => { setShowPassword(!showPassword) }}
                                                >
                                                    {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl fullWidth error={Boolean(touched.confirmPassword && errors.confirmPassword)}>

                                <Field
                                    value={values.confirmPassword}
                                    component={TextField}

                                    name="confirmPassword"
                                    label="Confirm Password"
                                    type={showPassword ? "text" : 'password'}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    margin="normal"
                                    variant="outlined"
                                    fullWidth
                                    InputProps={{

                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => { setShowPassword(!showPassword) }}
                                                >
                                                    {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid></Grid>

                }
                {values.hasOwnProperty("firstName") && <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth >

                        <Field
                            name="firstName"
                            label="First Name"
                            type="text"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.firstName}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            component={TextField}
                        />
                    </FormControl></Grid>
                }
                {values.hasOwnProperty("lastName") && <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth >

                        <Field
                            name="lastName"
                            label="Last Name"
                            type="text"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.lastName}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            component={TextField}
                        />
                    </FormControl></Grid>
                }
                {values.hasOwnProperty("email") && <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth >

                        <Field
                            name="email"
                            label="Email"
                            type="email"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.email}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            component={TextField}
                        />
                    </FormControl></Grid>
                }


                {values.hasOwnProperty("userName") && <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth error={Boolean(touched.userName && errors.userName)}>
                        <InputLabel htmlFor="outlined-status">Keycloak User</InputLabel>
                        <Select
                            value={values.userName}
                            variant="outlined"
                            name="userName"
                            label="Keycloak User"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            {users?.length > 0 && users?.map((item) => (
                                <MenuItem value={item.username}>
                                    {item.username}
                                </MenuItem>
                            ))}


                        </Select>
                        {errors.userName && <FormHelperText style={{ color: "red" }} >{errors.userName}</FormHelperText>}

                    </FormControl>

                </Grid>}
                {values.hasOwnProperty("connectionName") && <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth error={Boolean(touched.connectionName && errors.connectionName)}>
                        <InputLabel htmlFor="outlined-status">Connection Name</InputLabel>
                        <Select
                            value={values.connectionName}
                            variant="outlined"
                            name="connectionName"
                            label="Connection Name"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            <MenuItem value="Personnel">
                                Personnel
                            </MenuItem>


                        </Select>
                        {errors.connectionName && <FormHelperText style={{ color: "red" }} >{errors.connectionName}</FormHelperText>}

                    </FormControl></Grid>
                }
                {values.hasOwnProperty("connectionUser") && <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth error={Boolean(touched.connectionUser && errors.connectionUser)}>
                        <InputLabel htmlFor="outlined-status">Personnel User</InputLabel>
                        <Select
                            value={values.connectionUser}
                            variant="outlined"
                            name="userName"
                            label="PErsonnel User"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            {personnelUsers?.length > 0 && personnelUsers?.map((item) => (
                                <MenuItem value={item.User}>
                                    {item.User}
                                </MenuItem>
                            ))}


                        </Select>
                        {errors.connectionUser && <FormHelperText style={{ color: "red" }} >{errors.connectionUser}</FormHelperText>}

                    </FormControl></Grid>
                }
                {values.hasOwnProperty("connectionPass") && <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth >

                        <Field
                            name="connectionPass"
                            label="Connection Pass"
                            type="text"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.connectionPass}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            component={TextField}
                        />
                    </FormControl></Grid>
                }
            </Grid>
                <Grid item xs={12} md={12} sm={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        style={{ marginTop: '20px' }}
                        disabled={isSubmitting}>
                        {isSubmitting &&
                            <CircularProgress size={24} color='success' style={{ marginLeft: '10px' }} />} Save
                    </Button>
                    <Button variant="outlined" onClick={() => handleClose()} style={{ marginTop: '20px', marginLeft: '10px' }}>close</Button>

                </Grid>

         </Form>

    )

}
export default KeycloakUserCreationForm;